import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "../components/AuthProvider.tsx";
import Moment from "moment-timezone";
import BusinessItem from "../models/BusinessItem.tsx";
import MenuComponent from "../components/Menu.tsx";

function AdminProfiles() {
  const { authorization, SetAuthorization } = useAuth();

  const navigate = useNavigate();
  const [businesses, SetBusinesses] = useState<BusinessItem[]>([]);

  useEffect(() => {
    if (authorization) {
      fetch("/api/businesses?token=" + authorization.Token)
        .then(response => response.json())
        .then(data => SetBusinesses(data))
        .catch(error => console.log(error));
    }
  }, [authorization]);

  return (
    <>
      <MenuComponent page={"Employer Profiles"} />

      <section id="main">
        <div className="container">
          <div className="appList admPrf">
            <article>
              <div></div>
              <div>Employer Operating Name</div>
              <div>Contact Name</div>
              <div>Last Login Date</div>              
            </article>

            {businesses.map(business => (
              <article key={business.BusinessId}>
                <div>
                  <ul>
                    <li><a onClick={() => navigate("/admin/profile/" + business.BusinessId)}><img src="/images/icon-edit.png" alt="Incomplete Profile" title="Edit Profile" /></a></li>
                  </ul>
                </div>
                <div>{business.OperatingName}</div>
                <div>{business.Contact}</div>                
                <div>{business.LoggedOn && Moment.tz(business.LoggedOn, "America/Chicago").tz(Moment.tz.guess()).format("MMM DD, yyyy")}</div>
              </article>
            ))}
          </div>

          <p className="formButton biggerSpace"><a className="button" onClick={() => navigate("/admin/profile")}>Create Profile</a></p>
        </div>
      </section>
    </>
  );
}

export default AdminProfiles;